import PermissionButton from '../../permissions/PermissionButton';
import React, { useState } from 'react';
import { Input, Typography, Space, Button, message, DatePicker } from 'antd';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Text } = Typography;

const TitleRefEditor = ({ refFac, dateFac, onSave, onDateSave, disabled }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(refFac);
  const [isEditingDate, setIsEditingDate] = useState(false);
  const [editedDate, setEditedDate] = useState(dateFac ? moment(dateFac) : null);
  
  const handleEdit = () => {
    setEditedValue(refFac);
    setIsEditing(true);
  };

  const handleEditDate = () => {
    setEditedDate(dateFac ? moment(dateFac) : null);
    setIsEditingDate(true);
  };

  const handleSave = () => {
    // Validate that first two characters haven't changed
    if (editedValue.substring(0, 2) !== refFac.substring(0, 2)) {
      message.error('The first two characters cannot be modified');
      return;
    }

    // Validate that the new reference isn't empty
    if (!editedValue.trim()) {
      message.error('Reference cannot be empty');
      return;
    }

    onSave(editedValue);
    setIsEditing(false);
  };

  const handleDateSave = () => {
    if (!editedDate) {
      message.error('Date cannot be empty');
      return;
    }

    onDateSave(editedDate.format('YYYY-MM-DD'));
    setIsEditingDate(false);
  };

  const handleCancel = () => {
    setEditedValue(refFac);
    setIsEditing(false);
  };

  const handleDateCancel = () => {
    setEditedDate(dateFac ? moment(dateFac) : null);
    setIsEditingDate(false);
  };

  const formatDate = (date) => {
    if (!date) return "";
    return moment(date).format('DD/MM/YYYY');
  };

  return (
    <Space>
      {!isEditing ? (
        <>
          <Text strong style={{ fontSize: '16px' }}>{refFac}</Text>
          {!disabled && (
            <PermissionButton permissionModule="invoices" permissionAction="update"
              type="link" 
              icon={<EditOutlined />} 
              onClick={handleEdit}
              size="small"
            />
          )}
        </>
      ) : (
        <>
          <Input
            value={editedValue}
            onChange={(e) => setEditedValue(e.target.value)}
            style={{ 
              width: 200,
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          />
          <PermissionButton permissionModule="invoices" permissionAction="update"
            type="link" 
            icon={<SaveOutlined />} 
            onClick={handleSave}
            size="small"
          />
          <PermissionButton
            type="link" 
            danger 
            onClick={handleCancel}
            size="small"
          >
            Cancel
          </PermissionButton>
        </>
      )}

      {dateFac ? (
        !isEditingDate ? (
          <>
            <Text style={{ fontSize: '14px', marginLeft: '8px' }}>
              {formatDate(dateFac)}
            </Text>
            {!disabled && (
              <PermissionButton permissionModule="invoices" permissionAction="update"
                type="link" 
                icon={<EditOutlined />} 
                onClick={handleEditDate}
                size="small"
              />
            )}
          </>
        ) : (
          <>
            <DatePicker
              value={editedDate}
              onChange={setEditedDate}
              format="DD/MM/YYYY"
              style={{ marginLeft: '8px' }}
            />
            <PermissionButton permissionModule="invoices" permissionAction="update"
              type="link" 
              icon={<SaveOutlined />} 
              onClick={handleDateSave}
              size="small"
            />
            <PermissionButton
              type="link" 
              danger 
              onClick={handleDateCancel}
              size="small"
            >
              Cancel
            </PermissionButton>
          </>
        )
      ) : null}
    </Space>
  );
};

export default TitleRefEditor;